<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="animated fadeIn" ref="container">
          <div class="row align-items-center text-center">
            <div class="col-12 d-flex align-items-center justify-content-center" @click="openAddStoreOrderStatusModal">
              <button class="btn iconed btn-secondary"><i
                class="icon-bd-plus"></i><span>جدید</span></button>
            </div>
          </div>
          <!--          <vs-table ref="table" :params="params" :options="options"/>-->
        </div>
      </div>
    </div>
    <table class="table table-striped my-3">
      <thead>
      <tr>
        <th scope="col" class="text-center">عملیات</th>
        <th scope="col" class="text-center">ردیف</th>
        <th scope="col" class="text-center">شناسه در فروشگاه</th>
        <th scope="col" class="text-center">عنوان</th>
        <th scope="col" class="text-center">نوع</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in storeStatusResult">
        <td class="text-center" >
          <button :id="'btn-delete-' + item.id" class="btn btn-secondary"
                  :class="{'btn-danger': deleteButtonState === 'suspend'}" @click="onDeleteClicked(item, index)"><i
            class="icon-bd-delete"></i></button>
        </td>
        <th scope="row" class="text-center">{{index + 1}}</th>
<!--        <td class="text-center">{{storeIdToString(item.inStoreId)}}</td>-->
        <td class="text-center">{{item.inStoreId}}</td>
        <td class="text-center">{{item.title}}</td>
        <td class="text-center">{{item.statusName}}</td>
      </tr>
      </tbody>
    </table>

    <b-modal
      ref="addStoreStatus"
      id="store-status"
      size="lg"
      title="ایجاد وضعیت سفارش فروشگاه"
      ok-title="ذخیره"
      cancel-title="لغو"
      @cancel="hideModal"
      @ok="saveStoreOrderStatus"
    >
      <div class="row">
        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>شناسه در فروشگاه</span>
              </div>
            </div>
            <vs-select
              ref="storeId"
              :data="storeStates"
              :header="{label:'title'}"
              :mode="'create'"
              :is-header="true"
              @onChange="onStoreIdChange"
            ></vs-select>
          </div>
        </div>

        <div class="col-6">
          <div class="input-group">
            <div class="input-group-prepend custom">
              <div class="input-group-text">
                <span>عنوان</span>
              </div>
            </div>
            <vs-select
              ref="statusTitle"
              :data="statusTitles"
              :header="{label:'title'}"
              :mode="'create'"
              :is-header="true"
              @onChange="onStatusModeChange"
            ></vs-select>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
    import * as $ from 'jquery';
    import VsSelect from "../_framework/VsSelect";
    import BaseService from "../_framework/api/BaseService";
    import axios from "axios";


    export default {
        name: 'store-order-status',
        props: ['header'],
        components: {
            VsSelect
        },
        data() {
            return {
                show: true,
                storeId: null,
                storeIdVal: null,
                statusTitles: [],
                storeStatusResult: [],
                storeStates: [],
                deleteButtonState: "primary",
                mappingOrderStateModel: {
                    title: "",
                    inStoreId: 0,
                    status: 0
                }

            }
        },
        mounted() {
           this.getOrderStatusTableData();
            this.getStatusIdFromVsShop();
            this.getStoreOrderStatusTitles();
        },
        methods: {
            getStoreOrderStatusTitles() {
                new BaseService('Store', '/GetOrderStatusArray').getList().then((response) => {
                    this.statusTitles = response.data;
                }).catch((error) => {
                    console.log(error)
                })
            },
            getOrderStatusTableData() {
                new BaseService('Store', '/GetMappingOrderStates').getList().then((response) => {
                    this.storeStatusResult = response.data;
                }).catch((error) => {
                    console.log(error)
                })
            },
            getStatusIdFromVsShop() {
                axios
                    .get('https://lamkadeh.com/api/v1/warehouse/order_status?key=@%*STore^%!@')
                    .then(response => {
                        this.storeStates = response.data;

                    }).catch((error) => {
                })
            },
            onStoreIdChange(val) {

                if (val){
                    this.mappingOrderStateModel.inStoreId = val.id;
                    this.mappingOrderStateModel.title = val.title;
                }
            },
            onStatusModeChange(val) {
                if (val) {
                    this.mappingOrderStateModel.status = val.value;
                }

            },
            saveStoreOrderStatus() {
                new BaseService('Store', '/CreateMappingOrderState').create(this.mappingOrderStateModel).then((response) => {
                    this.$noty.success("وضعیت با موفقیت ثبت شد");
                    this.getOrderStatusTableData()
                }).catch((error) => {
                    console.log(error)
                })

            },
            openAddStoreOrderStatusModal() {

                this.$root.$emit('bv::show::addStoreStatus', 'store-status', '#btnShow')
                this.$refs.addStoreStatus.show()
            },
            onDeleteClicked(item) {
                const $btnDel = $(`#btn-delete-${item.id}`);
                if (!$btnDel.hasClass("btn-danger")) {
                    $btnDel.addClass("btn-danger");
                    setTimeout(() => {
                        $btnDel.removeClass("btn-danger");
                    }, 2000);
                } else {
                    new BaseService('Store', `/DeleteMappingOrderState/${item.id}`).delete().then((response) => {
                        this.$noty.success("حذف با موفقیت انجام شد");
                        this.getOrderStatusTableData();
                    }).catch((error) => {
                        console.log(error)
                    });
                }

            },
            btnEditClicked() {

            },
            hideModal() {
                this.$refs.addStoreStatus.hide();

                this.refreshTable();
            },
        }
    }
</script>

<style scoped>

</style>
